'use strict';

(function () {
    const self = Fotobook.config = {
        data: {},
        set(data) {
            Fotobook.store.commit('csrf/csrf', data[Fotobook.Settings.STATIC_CSRF]);
            delete data[Fotobook.Settings.STATIC_CSRF];
            // todo получение и хранение нужно полностью переделывать
            this.data = data;
            Fotobook.store.commit('user/updateUser', this.data.user);
            delete this.data.user;
            this.trigger();
        },

        trigger() {
            $(document).triggerHandler(Fotobook.events.APPCONFIG_CHANGED, [this]);
        },

        // todo перенести!!!
        setupHtmlClasses() {
            const guest = !Fotobook.store.state.user.id;
            $(document.documentElement)
                .toggleClass('guest', guest)
                .toggleClass('registered-user', !guest)
                .toggleClass('admin-user', !guest && Fotobook.store.state.user.admin);
        },
    };

    self.set(Fotobook.windowInitData.get('appconfig'));
    self.setupHtmlClasses();

    $(document)
        .on(Fotobook.events.APPCONFIG_CHANGED, () => self.setupHtmlClasses());
})();
